/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ServiceEventTicketDto } from "./ServiceEventTicketDto";
import {
    ServiceEventTicketDtoFromJSON,
    ServiceEventTicketDtoFromJSONTyped,
    ServiceEventTicketDtoToJSON,
} from "./ServiceEventTicketDto";

/**
 *
 * @export
 * @interface ServiceEventDto
 */
export interface ServiceEventDto {
    /**
     *
     * @type {number}
     * @memberof ServiceEventDto
     */
    serviceEventId?: number;
    /**
     * Cross-DB link to ScheduledMaintenance DeviceGroup
     * @type {string}
     * @memberof ServiceEventDto
     */
    scheduledMaintenanceDeviceGroupTag?: string;
    /**
     * Denormalized from device group
     * @type {string}
     * @memberof ServiceEventDto
     */
    scheduleName?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceEventDto
     */
    status?: ServiceEventDtoStatusEnum;
    /**
     * Denormalized site name
     * @type {string}
     * @memberof ServiceEventDto
     */
    siteName?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceEventDto
     */
    siteDeviceGroupTag?: string;
    /**
     * Denormalized organisation name
     * @type {string}
     * @memberof ServiceEventDto
     */
    organisationName?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceEventDto
     */
    organisationId?: string;
    /**
     *
     * @type {Date}
     * @memberof ServiceEventDto
     */
    scheduledDate?: Date;
    /**
     * Linked ticket IDs
     * @type {Array<ServiceEventTicketDto>}
     * @memberof ServiceEventDto
     */
    tickets?: Array<ServiceEventTicketDto>;
    /**
     *
     * @type {Date}
     * @memberof ServiceEventDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof ServiceEventDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const ServiceEventDtoStatusEnum = {
    Scheduled: "Scheduled",
    TicketCreated: "TicketCreated",
    Complete: "Complete",
} as const;
export type ServiceEventDtoStatusEnum =
    (typeof ServiceEventDtoStatusEnum)[keyof typeof ServiceEventDtoStatusEnum];

/**
 * Check if a given object implements the ServiceEventDto interface.
 */
export function instanceOfServiceEventDto(
    value: object,
): value is ServiceEventDto {
    return true;
}

export function ServiceEventDtoFromJSON(json: any): ServiceEventDto {
    return ServiceEventDtoFromJSONTyped(json, false);
}

export function ServiceEventDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ServiceEventDto {
    if (json == null) {
        return json;
    }
    return {
        serviceEventId:
            json["serviceEventId"] == null ? undefined : json["serviceEventId"],
        scheduledMaintenanceDeviceGroupTag:
            json["scheduledMaintenanceDeviceGroupTag"] == null
                ? undefined
                : json["scheduledMaintenanceDeviceGroupTag"],
        scheduleName:
            json["scheduleName"] == null ? undefined : json["scheduleName"],
        status: json["status"] == null ? undefined : json["status"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        siteDeviceGroupTag:
            json["siteDeviceGroupTag"] == null
                ? undefined
                : json["siteDeviceGroupTag"],
        organisationName:
            json["organisationName"] == null
                ? undefined
                : json["organisationName"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        scheduledDate:
            json["scheduledDate"] == null
                ? undefined
                : new Date(json["scheduledDate"]),
        tickets:
            json["tickets"] == null
                ? undefined
                : (json["tickets"] as Array<any>).map(
                      ServiceEventTicketDtoFromJSON,
                  ),
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function ServiceEventDtoToJSON(value?: ServiceEventDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        serviceEventId: value["serviceEventId"],
        scheduledMaintenanceDeviceGroupTag:
            value["scheduledMaintenanceDeviceGroupTag"],
        scheduleName: value["scheduleName"],
        status: value["status"],
        siteName: value["siteName"],
        siteDeviceGroupTag: value["siteDeviceGroupTag"],
        organisationName: value["organisationName"],
        organisationId: value["organisationId"],
        scheduledDate:
            value["scheduledDate"] == null
                ? undefined
                : value["scheduledDate"].toISOString(),
        tickets:
            value["tickets"] == null
                ? undefined
                : (value["tickets"] as Array<any>).map(
                      ServiceEventTicketDtoToJSON,
                  ),
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
